import { Route, Routes } from 'react-router-dom'
import SendOTPFP from '../auth/forgotPassword/SendOTPFP'
import UpdateForgotPassword from '../auth/forgotPassword/UpdateForgotPassword'
import VerifyOTPFP from '../auth/forgotPassword/VerifyOTPFP'
import AdminLogin from '../auth/login/AdminLogin'
import ChangeAdminPassword from '../auth/updatePassword/ChangeAdminPassword'
import ProtectedComponent from '../components/protectedComponent/ProtectedComponent'
import AddBanner from '../elements/addForms/banner/AddBanner'
import AddAccessory from '../elements/addForms/ecomm/AddAccessory'
import AddNewProduct from '../elements/addForms/ecomm/AddNewProduct'
import AddProductCategory from '../elements/addForms/ecomm/AddProductCategory'
import AddSubCategory from '../elements/addForms/ecomm/AddSubCategory'
import AddPincode from '../elements/addForms/pincode/AddPincode'
import AddTiffinPlan from '../elements/addForms/plans/AddTiffinPlan'
import UserSupportTable from '../elements/tables/supports/UserSupportTable'
import EditBanner from '../elements/updateForms/banner/EditBanner'
import EditAccessory from '../elements/updateForms/ecomm/EditAccessory'
import EditProduct from '../elements/updateForms/ecomm/EditProduct'
import EditProductCategory from '../elements/updateForms/ecomm/EditProductCategory'
import EditSubCategory from '../elements/updateForms/ecomm/EditSubCategory'
import DeliveryCharges from '../elements/updateForms/others/DeliveryCharges'
import DeliveryTimes from '../elements/updateForms/others/DeliveryTimes'
import EditPincode from '../elements/updateForms/pincode/EditPincode'
import EditTiffinPlan from '../elements/updateForms/plans/EditTiffinPlan'
import EditUser from '../elements/updateForms/users/EditUser'
import ViewAccessory from '../elements/views/ViewAccessory'
import ViewAssignJob from '../elements/views/ViewAssignJob'
import ViewBanner from '../elements/views/ViewBanner'
import ViewCategory from '../elements/views/ViewCategory'
import ViewOrder from '../elements/views/ViewOrder'
import ViewOrderType from '../elements/views/ViewOrderType'
import ViewPinCode from '../elements/views/ViewPincode'
import ViewPricing from '../elements/views/ViewPricing'
import ViewProduct from '../elements/views/ViewProduct'
import ViewReturn from '../elements/views/ViewReturn'
import ViewSubCategory from '../elements/views/ViewSubCategory'
import ViewSupport from '../elements/views/ViewSupport'
import ViewTiffinPlan from '../elements/views/ViewTiffinPlan'
import ViewUser from '../elements/views/ViewUser'
import AssignJobs from '../pages/assignJobs/AssignJobs'
import Banner from '../pages/banners/Banner'
import Dashboard from '../pages/dashboard/Dashboard'
import AllProducts from '../pages/ecomm/AllProducts'
import ProductCategroies from '../pages/ecomm/ProductCategroies'
import OrderByType from '../pages/orders/OrderByType'
import Orders from '../pages/orders/Orders'
import Pincode from '../pages/pincode/Pincode'
import TiffinPlan from '../pages/plans/TiffinPlan'
import Returns from '../pages/returns/Returns'
import PrivacyPolicy from '../pages/settings/PrivacyPolicy'
import TNC from '../pages/settings/TNC'
import AllSupports from '../pages/support/AllSupports'
import ActiveUsers from '../pages/users/ActiveUsers'
import BlockedUsers from '../pages/users/BlockedUsers'
import DeletedUsers from '../pages/users/DeletedUsers'
import InactiveUsers from '../pages/users/InactiveUsers'
import DeletedDrivers from '../pages/driver/DeletedDrivers'
import Homepage from '../website/pages/Homepage'
import PrivacyPolicyPage from '../website/pages/PrivacyPolicyPage'
import OrderMain from '../pages/orders/OrderMain'
import ContactUs from '../pages/settings/ContactUs'
import Settings from '../pages/settings/Settings'
import AdminUser from '../pages/Admin'
import AddAdminUser from '../elements/addForms/ecomm/AddAdminUser'
import EditAdminUser from '../elements/updateForms/users/EditAdminUser'
import DriverUser from '../pages/driver/Driver'
import EditDriver from '../elements/updateForms/driver/EditDriver'
import CancelOrders from '../pages/cancel/CancelOrders'
import ViewCancel from '../elements/views/ViewCancel'
import AddMealType from '../elements/addForms/ecomm/AddMealType'
import EditMealType from '../elements/updateForms/ecomm/EditMealType'
import ViewMealType from '../elements/views/ViewMealType'
import AddWarehouse from '../elements/addForms/warehouse/AddWarehouse'
import Warehouse from '../pages/warehouse/Warehouse'
import ViewWarehouse from '../elements/views/ViewWarehouse'
import EditWarehouse from '../elements/updateForms/warehouse/EditWarehouse'
import ViewDriverWallet from '../elements/views/ViewDriverWallet'
import OrderReport from '../pages/reports/order'

export default function AllRoutes() {
  return (
    <div>
      <Routes>
        {/* Admin Auth */}
        <Route path="/" element={<Homepage />}></Route>
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />}></Route>
        <Route path="/admin-panel/login" element={<AdminLogin />}></Route>
        <Route path="/admin-panel/send-otp" element={<SendOTPFP />}></Route>
        <Route path="/admin-panel/verify-otp" element={<VerifyOTPFP />}></Route>
        <Route path="/admin-panel/update-forgot-password" element={<UpdateForgotPassword />}></Route>

        <Route element={<ProtectedComponent />}>

          {/* Dashboard Section */}
          <Route path="/admin-panel/dashboard" element={<Dashboard />}></Route>

          {/* User Section */}
          <Route path="/admin-panel/user/active-users/:pageNo" element={<ActiveUsers />}></Route>
          <Route path="/admin-panel/user/inactive-users/:pageNo" element={<InactiveUsers />}></Route>
          <Route path="/admin-panel/user/blocked-users/:pageNo" element={<BlockedUsers />}></Route>
          <Route path="/admin-panel/user/deleted-users/:pageNo" element={<DeletedUsers />}></Route>
          <Route path="/admin-panel/user/view/:id" element={<ViewUser />}></Route>
          <Route path="/admin-panel/user/edit/:id" element={<EditUser />}></Route>

          <Route path="/admin-panel/adminuser/:pageNo" element={<AdminUser />}></Route>

          <Route path='/admin-panel/adminusers/add' element={<AddAdminUser />}></Route>
          <Route path='/admin-panel/adminusers/edit/:id' element={<EditAdminUser />}></Route>


          {/* Assign Jobs */}
          <Route path="/admin-panel/assigning-job/:name/:serviceId/:pageNo" element={<AssignJobs />} ></Route>
          <Route path='/admin-panel/assigning-job/view/:id' element={<ViewAssignJob />}></Route>
          <Route path="/admin-panel/order-report/:pageNo" element={<OrderReport />} ></Route>

          <Route path="/admin-panel/cancel/:name/:serviceId/:pageNo" element={<CancelOrders />} ></Route>
          <Route path='/admin-panel/cancel/view/:id' element={<ViewCancel />}></Route>

          {/* <Route path="/admin-panel/assigning-job/oxygen/:pageNo" element={<Orders />} ></Route>
          <Route path="/admin-panel/assigning-job/laundry/:pageNo" element={<Orders />} ></Route>
          <Route path="/admin-panel/assigning-job/tiffin/:pageNo" element={<Orders />} ></Route>
          <Route path="/admin-panel/assigning-job/meals/:pageNo" element={<Orders />} ></Route>
          <Route path="/admin-panel/assigning-job/home-solutions/:pageNo" element={<Orders />} ></Route> */}

          {/* E-commerce Section */}
          <Route path='/admin-panel/category/add' element={<AddProductCategory />}></Route>
          <Route path='/admin-panel/categories/:pageNo' element={<ProductCategroies />}></Route>
          <Route path='/admin-panel/category/edit/:id' element={<EditProductCategory />}></Route>
          <Route path='/admin-panel/category/view/:id' element={<ViewCategory />}></Route>

          <Route path='/admin-panel/pricing/:CategoryName/:id' element={<ViewPricing />}></Route>


          <Route path='/admin-panel/sub-category/add/:id' element={<AddSubCategory />}></Route>
          <Route path='/admin-panel/sub-category/edit/:id' element={<EditSubCategory />}></Route>
          <Route path='/admin-panel/sub-category/view/:id' element={<ViewSubCategory />}></Route>

          <Route path='/admin-panel/accessory/add/:id' element={<AddAccessory />}></Route>
          <Route path='/admin-panel/accessory/edit/:id' element={<EditAccessory />}></Route>
          <Route path='/admin-panel/accessory/view/:id' element={<ViewAccessory />}></Route>

          
          <Route path='/admin-panel/mealtype/add/:id' element={<AddMealType />}></Route>
          <Route path='/admin-panel/mealtype/edit/:id' element={<EditMealType />}></Route>
          <Route path='/admin-panel/mealtype/view/:id' element={<ViewMealType />}></Route>


          <Route path='/admin-panel/product/add/:id' element={<AddNewProduct />}></Route>
          <Route path='/admin-panel/product/edit/:id' element={<EditProduct />}></Route>
          <Route path='/admin-panel/product/view/:id' element={<ViewProduct />}></Route>
          <Route path='/admin-panel/ecomm/all-products/:pageNo' element={<AllProducts />}></Route>

          {/* Orders Management */}

          <Route path='/admin-panel/orders/:pageNo' element={<OrderMain />}></Route>

          <Route path='/admin-panel/order/:serviceId/:pageNo' element={<Orders />}></Route>
          <Route path='/admin-panel/order/view/:id' element={<ViewOrder />}></Route>
          <Route path='/admin-panel/orders/:type/:pageNo' element={<OrderByType />}></Route>
          <Route path='/admin-panel/order-type/view/:id' element={<ViewOrderType />}></Route>

          {/* Pincodes Management */}
          <Route path='/admin-panel/pincode/add' element={<AddPincode />}></Route>
          <Route path='/admin-panel/pincodes/:pageNo' element={<Pincode />}></Route>
          <Route path='/admin-panel/pincode/view/:id' element={<ViewPinCode />}></Route>
          <Route path='/admin-panel/pincode/edit/:id' element={<EditPincode />}></Route>

          <Route path='/admin-panel/warehouse/add' element={<AddWarehouse />}></Route>
          <Route path='/admin-panel/warehouse/:pageNo' element={<Warehouse />}></Route>
          <Route path='/admin-panel/warehouse/view/:id' element={<ViewWarehouse />}></Route>
          <Route path='/admin-panel/warehouse/edit/:id' element={<EditWarehouse />}></Route>


          {/* Returns Management */}
          {/* <Route path='/admin-panel/returns/:pageNo' element={<Returns />}></Route> */}
          <Route path='/admin-panel/returns/:catgId/:pageNo' element={<Returns />}></Route>
          <Route path='/admin-panel/return/view/:id' element={<ViewReturn />}></Route>

          {/* Banners Management */}
          <Route path='/admin-panel/banner/add' element={<AddBanner />}></Route>
          <Route path='/admin-panel/banner/edit/:bannerId' element={<EditBanner />}></Route>
          <Route path='/admin-panel/banners/:pageNo' element={<Banner />}></Route>
          <Route path='/admin-panel/banners/:id/:pageNo' element={<Banner />}></Route>
          <Route path='/admin-panel/banner/view/:id' element={<ViewBanner />}></Route>

          {/* REturn Orders */}
          <Route path='/admin-panel/tiffin-plans/:pageNo' element={<TiffinPlan />}></Route>
          <Route path='/admin-panel/tiffin-plan/add' element={<AddTiffinPlan />}></Route>
          <Route path='/admin-panel/tiffin-plan/edit/:planId' element={<EditTiffinPlan />}></Route>
          <Route path='/admin-panel/tiffin-plan/view/:planId' element={<ViewTiffinPlan />}></Route>


          {/* Support Mamangement */}
          <Route path='/admin-panel/supports/:pageNo' element={<AllSupports />}></Route>
          <Route path='/admin-panel/support/view/:userId' element={<UserSupportTable />}></Route>
          <Route path='/admin-panel/support/view-support/:id' element={<ViewSupport />}></Route>

          <Route path='/admin-panel/delivery-charges/edit' element={<DeliveryCharges />}></Route>
          <Route path='/admin-panel/delivery-times/edit' element={<DeliveryTimes />}></Route>

          <Route path='/admin-panel/change-password' element={<ChangeAdminPassword />}></Route>
          <Route path='/admin-panel/privacy-policy' element={<PrivacyPolicy />}></Route>
          <Route path='/admin-panel/terms-and-conditions' element={<TNC />}></Route>
          <Route path='/admin-panel/contact-us' element={<ContactUs />}></Route>
          <Route path='/admin-panel/settings' element={<Settings />}></Route>

          <Route path="/admin-panel/driver/:pageNo" element={<DriverUser />}></Route>
          <Route path="/admin-panel/driver/deleted/:pageNo" element={<DeletedDrivers />}></Route>
          <Route path='/admin-panel/driver/edit/:id' element={<EditDriver />}></Route>
          <Route path='/admin-panel/driver/wallet/:id' element={<ViewDriverWallet />}></Route>

        </Route>
      </Routes>
    </div>
  )
}
